import { Injectable, inject } from "@angular/core";
import { Subscription } from "rxjs";
import { IPopoverOptions, PopoverConfig, PopoverRef, PopoverService } from "@tylertech/forge-angular";
import { ContextMenuComponent } from "../components";

@Injectable()
export class ContextMenuService
{
    private readonly forgePopoverService = inject(PopoverService);

    protected popoverSubscription: Subscription;
    protected popoverRef: PopoverRef<ContextMenuComponent>;

    showContextMenu(popupOptions: IPopoverOptions, popupConfig?: PopoverConfig)
    {
        this.popoverRef = this.forgePopoverService.show(ContextMenuComponent, popupOptions, popupConfig);
        this.popoverSubscription = this.popoverRef.afterClosed
            .subscribe(() =>
            {
                this.popoverRef = undefined;
                this.popoverSubscription = undefined;
            });
    }

    closePopovers(): void
    {
        this.popoverSubscription?.unsubscribe();
        this.popoverSubscription = undefined;
        this.popoverRef?.close();
        this.popoverRef = undefined;
    }
}